export default function Privacy() {
  return (
    <div style={styles.container}>
      <h1>Aviso de Privacidad</h1>

      <p>
        En cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares
      </p>

      <h3>1. Responsable</h3>
      <p>Daniel Rubies Isla, operando como “Korners”.</p>

      <h3>2. Datos recopilados</h3>
      <p>Nombre, teléfono, correo electrónico, información del inmueble.</p>

      <h3>3. Finalidad</h3>
      <p>Proveer servicios, contacto con clientes y facturación.</p>

      <h3>4. Transferencia</h3>
      <p>No se comparten datos con terceros salvo obligación legal.</p>

      <h3>5. Derechos ARCO</h3>
      <p>
        Acceder, rectificar, cancelar u oponerse enviando solicitud a:
        <br />
        <strong>danielrubiesisla@gmail.com</strong>
      </p>

      <h3>6. Seguridad</h3>
      <p>
        Se implementan medidas razonables para proteger los datos, sin garantizar seguridad absoluta.
      </p>

      <h3>7. Cambios</h3>
      <p>Este aviso puede modificarse en cualquier momento.</p>
    </div>
  );
}

const styles = {
  container: {
    padding: "40px",
    maxWidth: "800px",
    margin: "auto",
    lineHeight: "1.6",
  },
};